<template>
  <div>
    <div class="lifestyle-pricelist-itemdetails" v-if="!isModalLoading">
      <div v-if="adItem.length > 0">
        <div v-for="(item, index) in adItem" :key="index" class="lifestyle-pricelist-itemdetails__item">
          <h1 class="subhead title">{{item.name}}</h1>
          <div v-if="item.quantity" class="lifestyle-pricelist-itemdetails__row">
            <div class="subhead">Quantity per Package</div>
            <h1>{{item.quantity}} Item(s)</h1>
          </div>
          <div v-if="item.size" class="lifestyle-pricelist-itemdetails__row">
            <div class="subhead">Item / Device Size</div>
            <h1>{{item.size}}</h1>
          </div>
          <div v-if="item.orientation" class="lifestyle-pricelist-itemdetails__row">
            <div class="subhead">Orientation</div>
            <h1>{{item.orientation}}</h1>
          </div>
          <div v-if="item.material" class="lifestyle-pricelist-itemdetails__row">
            <div class="subhead">Material</div>
            <h1>{{item.material}}</h1>
          </div>
          <div v-if="item.file_requirment" class="lifestyle-pricelist-itemdetails__row">
            <div class="subhead">File Requirement</div>
            <h1>{{item.file_requirment}}</h1>
          </div>
        </div>
      </div>
      <div v-else>
        <adx-empty-selection />
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";

import EmptySelection from "@/components/NotFound/Selection";

export default {
  name: "adx-lifestyle-placement-itemDetails",
  components: {
    "a-loading": ALoadingPrimary,
    "adx-empty-selection": EmptySelection
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      adItem: [],
      // quantityPerPackage: null,
      // size: null,
      // orientation: null,
      // material: null,
      // fileRequirement: null
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.lifestylePricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.adItem = data.items;
        // this.quantityPerPackage = "-";
        // this.size = "-";
        // this.orientation = "-";
        // this.material = "-";
        // this.fileRequirement = "-";
      }

      this.isModalLoading = false;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
